import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';

const Features: React.FC = () => {
  const { t } = useTranslation();
  const featuresList = ['ops', 'tracking', 'hazmat', 'partners'];

  return (
    <div className="py-24 bg-slate-900 text-white overflow-hidden relative">
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-marine-600/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-marine-400/10 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6">{t('features.title')}</h2>
            <p className="text-slate-300 text-lg mb-8 leading-relaxed">
              {t('features.desc')}
            </p>
            
            <div className="space-y-6">
              {featuresList.map((item, idx) => (
                <div key={idx} className="flex items-center gap-4 group">
                  <div className="h-10 w-10 rounded-full bg-marine-500/20 flex items-center justify-center group-hover:bg-marine-500 transition-colors">
                    <CheckCircle2 className="h-6 w-6 text-marine-400 group-hover:text-white transition-colors" />
                  </div>
                  <span className="text-lg font-medium text-slate-200">{t(`features.list.${item}`)}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 p-6 bg-white/5 rounded-xl border border-white/10 backdrop-blur-sm">
               <p className="text-xl text-center text-marine-200">
                 "{t('features.quote')}"
               </p>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10">
              <img 
                src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" 
                alt="Logistics Operations" 
                className="w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent flex items-end p-8">
                 <div>
                    <h3 className="text-2xl font-bold">{t('features.port_ops')}</h3>
                    <p className="text-marine-300">{t('features.jeddah')}</p>
                 </div>
              </div>
            </div>
            
            {/* Floating Card */}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
